import Card from "components/Card";
import Button from "components/Button";
import CheckedComponent from "components/CheckedComponent";
import Badge from "components/Badge";
import { Tooltip } from "components/Tooltip";
import Messages from "misc/Messages";

interface EnterprisePlanCardProps {
  onContactSalesClick: () => void;
  isYearly?: boolean;
}

export default function EnterprisePlanCard({
  onContactSalesClick,
  isYearly,
}: EnterprisePlanCardProps) {
  return (
    <Card
      borderless
      fullHeight
      className="relative min-w-0 !h-full rounded-lg border !border-primary-200 !overflow-visible"
    >
      <div className="flex flex-col w-full h-full rounded-lg bg-gradient-to-r from-[#F0F8FF] to-white">
        <div className="px-4 pt-4">
          <h3 className="text-2xl leading-8 font-semibold text-neutral-900 dark:text-white whitespace-nowrap">
            Enterprise
          </h3>
          <div className="relative mt-4">
            <div aria-hidden className="flex flex-col gap-1 invisible">
              {isYearly && (
                <p className="text-sm leading-5 whitespace-nowrap">$0</p>
              )}
              <div className="flex items-end gap-1 whitespace-nowrap">
                <span className="text-4xl font-semibold leading-10">$0</span>
                <span className="text-sm leading-5">/ month</span>
              </div>
              {isYearly && (
                <p className="text-sm leading-5 mt-1 whitespace-nowrap">Billed annually</p>
              )}
            </div>
            <p className="absolute inset-0 text-xs leading-4 text-[#465c6f] dark:text-gray-400">
              {Messages.billingV2.enterprise.tagline}
            </p>
          </div>
          <div className="mt-4">
            <Button
              text="CONTACT SALES"
              className="button button-secondary rounded w-full"
              size="SM"
              onClick={onContactSalesClick}
            />
          </div>
        </div>

        <div className="mt-4">
          <hr className="border-t border-primary-200" />
        </div>

        <div className="mt-4 grid grid-cols-1 gap-3 px-4 pb-4">
          {Messages.billingV2.enterprise.features.map((feature, index) => (
            <CheckedComponent
              key={index}
              variant="circle"
              highlighted
              iconSize="w-4 h-4"
              className="text-sm text-gray-900 dark:text-white"
            >
              <span className="inline-flex items-center gap-2">
                {feature.infoTooltip ? (
                  <Tooltip content={feature.infoTooltip}>
                    {feature.label}
                  </Tooltip>
                ) : (
                  feature.label
                )}
                {feature.badge === "new" && <Badge textColorClass="text-gray-900" />}
              </span>
            </CheckedComponent>
          ))}
        </div>
      </div>
    </Card>
  );
}
